import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import video1 from '../assets/video1.mp4';
import video2 from '../assets/video2.mp4';
import video3 from '../assets/video3.mp4';

const videos = [
    {
        id: 1,
        name: 'Rini Richard',
        program: 'Online MBA – DPU COL.',
        quote: 'iGrade changed my career completely.',
        src: video1,
    },
    {
        id: 2,
        name: 'Tanuja',
        program: 'Online MCA – DPU Pimpri',
        quote: 'Enrolled in a week. Zero stress.',
        src: video2,
    },
    {
        id: 3,
        name: 'Yash Dakhle',
        program: 'MBA – DY Patil University',
        quote: 'Best decision of my professional life.',
        src: video3,
    },
];

export default function VideoTestimonials() {
    const [open, setOpen] = useState(false);
    const [active, setActive] = useState(0);

    useEffect(() => {
        document.body.style.overflow = open ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [open]);

    const close = () => setOpen(false);

    return (
        <>
            {/* Trigger button */}
            <button
                onClick={() => setOpen(true)}
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: 10,
                    marginTop: 28,
                    background: 'var(--yellow)', color: 'var(--navy)',
                    padding: '13px 24px', borderRadius: 10,
                    fontWeight: 700, fontSize: 14,
                    border: 'none', cursor: 'pointer',
                    fontFamily: 'DM Sans,sans-serif',
                    transition: 'all 0.25s',
                    boxShadow: '0 4px 20px rgba(245,197,24,0.3)',
                }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 8px 28px rgba(245,197,24,0.4)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(245,197,24,0.3)'; }}
            >
                <span style={{
                    width: 32, height: 32, borderRadius: '50%',
                    background: 'var(--navy)', display: 'grid', placeItems: 'center',
                    fontSize: 12, flexShrink: 0, color: 'var(--yellow)',
                }}>▶</span>
                Watch Student Testimonials
            </button>

            <AnimatePresence>
                {open && (
                    <>
                        {/* Backdrop */}
                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            exit={{ opacity: 0 }}
                            onClick={close}
                            style={{
                                position: 'fixed', inset: 0, zIndex: 1200,
                                background: 'rgba(7,21,53,0.9)',
                                backdropFilter: 'blur(8px)',
                            }}
                        />

                        {/* Centering wrapper */}
                        <div style={{
                            position: 'fixed', zIndex: 1201,
                            top: 0, left: 0, width: '100%', height: '100%',
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            padding: '20px', pointerEvents: 'none',
                        }}>
                            <motion.div
                                initial={{ opacity: 0, y: 40, scale: 0.96 }}
                                animate={{ opacity: 1, y: 0, scale: 1 }}
                                exit={{ opacity: 0, y: 24, scale: 0.96 }}
                                transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
                                onClick={e => e.stopPropagation()}
                                style={{
                                    pointerEvents: 'auto',
                                    width: '100%', maxWidth: 960,
                                    maxHeight: '92vh',
                                    borderRadius: 20, overflow: 'hidden',
                                    display: 'flex', flexDirection: 'column',
                                    boxShadow: '0 40px 120px rgba(0,0,0,0.6)',
                                    background: 'var(--navy)',
                                }}
                            >
                                {/* Header */}
                                <div style={{
                                    padding: '18px 28px',
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    borderBottom: '1px solid rgba(245,197,24,0.2)', flexShrink: 0,
                                }}>
                                    <div>
                                        <div style={{
                                            display: 'inline-block', background: 'var(--yellow)', color: 'var(--navy)',
                                            fontSize: 10, fontWeight: 800, padding: '4px 12px', borderRadius: 999,
                                            letterSpacing: '1px', textTransform: 'uppercase', marginBottom: 6,
                                        }}>Student Stories</div>
                                        <h2 style={{
                                            fontFamily: 'Playfair Display,serif', fontSize: 20,
                                            color: '#fff', margin: 0,
                                        }}>Real Students. Real Results.</h2>
                                    </div>
                                    <button
                                        onClick={close}
                                        style={{
                                            width: 36, height: 36, borderRadius: '50%',
                                            background: 'rgba(255,255,255,0.1)', border: 'none',
                                            color: '#fff', fontSize: 18, cursor: 'pointer',
                                            display: 'grid', placeItems: 'center',
                                            transition: 'background 0.2s', flexShrink: 0,
                                            fontFamily: 'DM Sans,sans-serif',
                                        }}
                                        onMouseEnter={e => e.currentTarget.style.background = 'rgba(255,255,255,0.2)'}
                                        onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.1)'}
                                    >✕</button>
                                </div>

                                {/* Body: two-column layout */}
                                <div style={{
                                    display: 'flex',
                                    flex: 1,
                                    minHeight: 0, // critical: allows children to scroll within flex parent
                                    overflow: 'hidden',
                                }}>
                                    {/* Left: video + info */}
                                    <div style={{
                                        flex: '1 1 0',
                                        display: 'flex', flexDirection: 'column',
                                        minWidth: 0,
                                        borderRight: '1px solid rgba(255,255,255,0.08)',
                                    }}>
                                        {/* Video player — maintains 16:9 */}
                                        <div style={{
                                            position: 'relative', width: '100%',
                                            paddingTop: '56.25%', background: '#000', flexShrink: 0,
                                        }}>
                                            <video
                                                key={active}
                                                src={videos[active].src}
                                                controls
                                                autoPlay
                                                controlsList="nodownload"
                                                style={{
                                                    position: 'absolute', top: 0, left: 0,
                                                    width: '100%', height: '100%', background: '#000',
                                                }}
                                            />
                                        </div>

                                        {/* Active video info */}
                                        <div style={{
                                            padding: '16px 24px',
                                            flexShrink: 0,
                                        }}>
                                            <p style={{ fontSize: 15, fontWeight: 700, color: '#fff', margin: 0 }}>
                                                {videos[active].name}
                                                <span style={{ color: 'var(--yellow)', marginLeft: 10, fontSize: 13, fontWeight: 600 }}>
                                                    {videos[active].program}
                                                </span>
                                            </p>
                                            <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.5)', marginTop: 4, marginBottom: 0 }}>
                                                {videos[active].location && `📍 ${videos[active].location} • `}"{videos[active].quote}"
                                            </p>
                                        </div>
                                    </div>

                                    {/* Right: thumbnail list */}
                                    <div style={{
                                        width: 260,
                                        flexShrink: 0,
                                        display: 'flex', flexDirection: 'column',
                                        gap: 10,
                                        padding: '16px',
                                        overflowY: 'auto',
                                    }}>
                                        <p style={{
                                            fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.4)',
                                            textTransform: 'uppercase', letterSpacing: '1px',
                                            margin: '0 0 4px 0', flexShrink: 0,
                                            fontFamily: 'DM Sans,sans-serif',
                                        }}>All Stories</p>

                                        {videos.map((v, i) => (
                                            <button
                                                key={v.id}
                                                onClick={() => setActive(i)}
                                                style={{
                                                    width: '100%',
                                                    background: active === i ? 'rgba(245,197,24,0.15)' : 'rgba(255,255,255,0.05)',
                                                    border: `1.5px solid ${active === i ? 'var(--yellow)' : 'rgba(255,255,255,0.1)'}`,
                                                    borderRadius: 12, padding: '14px 16px',
                                                    cursor: 'pointer', textAlign: 'left',
                                                    transition: 'all 0.2s', fontFamily: 'DM Sans,sans-serif',
                                                    flexShrink: 0,
                                                }}
                                                onMouseEnter={e => { if (active !== i) e.currentTarget.style.background = 'rgba(255,255,255,0.08)'; }}
                                                onMouseLeave={e => { if (active !== i) e.currentTarget.style.background = 'rgba(255,255,255,0.05)'; }}
                                            >
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 6 }}>
                                                    <div style={{
                                                        width: 28, height: 28, borderRadius: '50%',
                                                        background: active === i ? 'var(--yellow)' : 'rgba(255,255,255,0.15)',
                                                        display: 'grid', placeItems: 'center',
                                                        fontSize: 11, flexShrink: 0,
                                                        color: active === i ? 'var(--navy)' : '#fff',
                                                    }}>▶</div>
                                                    <span style={{
                                                        fontSize: 13, fontWeight: 700,
                                                        color: active === i ? 'var(--yellow)' : '#fff',
                                                    }}>{v.name}</span>
                                                </div>
                                                <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.5)', margin: 0 }}>
                                                    {v.program}
                                                </p>
                                                {v.location && (
                                                    <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.35)', margin: '4px 0 0 0' }}>
                                                        📍 {v.location}
                                                    </p>
                                                )}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                            </motion.div>
                        </div>
                    </>
                )}
            </AnimatePresence>
        </>
    );
}